import Vue from 'vue';
import VueRouter from 'vue-router';
import Chat from '@/pages/Chat/Chat.vue';
import Login from '@/pages/Login/Login.vue';
import Register from '@/pages/Register/Register.vue';
import Admin from '@/pages/Admin/Admin.vue';
import Order from '@/pages/Payment/order.vue';
import OrderList from '@/pages/OrderList/OrderList.vue';
import CostDetail from '@/pages/CostDetail/CostDetail.vue';
import PaySuccess from '@/pages/PaySuccess/PaySuccess.vue';
import Building from '@/pages/Building/Building.vue';
import Coupon from '@/pages/Coupon/Coupon.vue';
import NotFound from '@/pages/404/404.vue';
import TextChat from '@/pages/TextChat/TextChat.vue';
import Favorite from '@/pages/Favorite/Favorite.vue';
import UseRule from '@/pages/UseRule/UseRule.vue';
import About from '@/pages/About/About.vue';
import Privacy from '@/pages/Privacy/Privacy.vue';
import Contact from '@/pages/Contact/Contact.vue';
import Refund from '@/pages/Refund/Refund.vue';
import Prize from '@/pages/Prize/Prize.vue';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'chat',
    component: Chat,
    children: [
      {
        path: 'text',
        component: TextChat
      },

      {
        path: 'text/:chatId',
        component: TextChat
      }
    ]
  },
  {
    path: '/userule',
    name: 'UseRule',
    component: UseRule,
  },
  {
    path: '/about',
    name: 'About',
    component: About,
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
  },
  {
    path: '/refund',
    name: 'Refund',
    component: Refund,
  },
  {
    path: '/prize/:convertCode',
    name: 'prize',
    component: Prize,
  },
  {
    path: '*',
    name: 'notFound',
    component: NotFound
  },
];

const router = new VueRouter({
  base: '/desktop',
  routes,
  mode: 'history'
});

function jumpToAuth() {
  const redirectURL = window.location.href.split('?')[0];

  if (/pre-chat.cozytaps.com/.test(redirectURL)) {
    window.location.href = `https://pre-auth.cozytaps.com/web?appid=01e5928099b54933bcf1ebad2bf81c32&redirect_url=${encodeURIComponent(redirectURL)}`;
    return;
  }

  window.location.href = `https://auth.cozytaps.com/web?appid=01e5928099b54933bcf1ebad2bf81c32&redirect_url=${encodeURIComponent(redirectURL)}`;
}

// 登录态控制路由规则
router.beforeEach((to, from, next) => {
  const isLogin = store.getters.isLogin;
  const isManager = store.getters.userType === 'manager';
  
  // 除此之外没有登录，全部重定向到登录页去
  if (!isLogin) {
    jumpToAuth();
    return;
  }

  if (to.path === '/') {
    next('/text');
    return;
  }

  next();
})

export default router;



